export default function getFullName(user?: { first_name: string; last_name: string; }) {
    return `${user?.first_name} ${user?.last_name}`;
}
